import { useTheme } from "../../../../context/theme";
import useForegroundVariantColor from "../../../../styles/colors/surfaces/useForegroundVariantColor";
import { getDimensionPx } from "../../../../styles/dimensions/dimensions";
import { Box } from "../../../layout";
import { AvatarSize, avatarSizeToStylesMap, AvatarState } from "../consts";

type Props = {
  avatarState: AvatarState;
  avatarSize: AvatarSize;
  children: React.ReactNode;
};

export default function InnerCircle({
  avatarState,
  avatarSize,
  children
}: Props) {
  const foregroundVariantColor = useForegroundVariantColor("2");
  const theme = useTheme();

  const { widthAndHeight, insetAndBorderWidth } = avatarSizeToStylesMap[
    avatarSize
  ];

  const insetWidth = getDimensionPx(insetAndBorderWidth);

  return (
    <Box
      backgroundColor={foregroundVariantColor}
      width={widthAndHeight}
      height={widthAndHeight}
      borderRadius="xxxlarge"
      position="relative"
      boxShadow={
        avatarState !== "default"
          ? `0 0 0 ${insetWidth} ${theme.foreground} inset`
          : undefined
      }
    >
      {children}
    </Box>
  );
}
